import { render, staticRenderFns } from "./Schemes.vue?vue&type=template&id=37402b85&scoped=true"
import script from "./Schemes.vue?vue&type=script&lang=js"
export * from "./Schemes.vue?vue&type=script&lang=js"
import style0 from "./Schemes.vue?vue&type=style&index=0&id=37402b85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37402b85",
  null
  
)

export default component.exports